import * as htmlToImage from "html-to-image";
import { useImageStore } from "../use-image-store";
import { getSnapshot } from "PosterEditor/utils/db";
import { SaveImageConfig } from "../use-image-store-remote";

export const useImageSnapshotStore = () => {
  const { saveImage, saveImageWithThumbnails, getImageUrl } = useImageStore();

  const storeSnapshot = async (
    base64DataUrl: string,
    existingID: string,
    isPublic: boolean
  ): Promise<string | null> => {
    try {
      const response = await fetch(base64DataUrl);
      const blob = await response.blob();

      const saveConfig: SaveImageConfig = {
        image: blob,
        existingFilename: existingID,
        isPublic: isPublic,
        mimeTypeParam: blob.type,
      };

      // For public images (templates), generate pre-sized thumbnails to avoid Supabase transform limits
      // For private images (user projects), just save the original
      const id = isPublic
        ? await saveImageWithThumbnails(saveConfig)
        : await saveImage(saveConfig);

      return id;
    } catch (error) {
      console.error("Snapshot save failed", error);
      return null;
    }
  };

  return { storeSnapshot, getSnapshot: getImageUrl };
};
